module.exports = __webpack_public_path__ + "3c18433afdadc2231c3316418720d5ad.png";